import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { environment } from "src/environments/environment";
import { Market } from "../models/market.model";

@Injectable({ providedIn: "root" })
export class MarketService {
  private httpClient = inject(HttpClient);

  private apiUrl = environment.apiUrl + "/market";

  getAll() {
    return this.httpClient.get<Market[]>(`${this.apiUrl}/getAll`);
  }

  getAllEnabled() {
    return this.httpClient.get<Market[]>(`${this.apiUrl}/getAllEnabled`);
  }
}
